import { getCurrentInstance } from "vue";

type ToastMessage = {
  severity?: string;
  summary?: string;
  detail?: string;
  life?: number;
  group?: string;
  styleClass?: string;
  contentStyleClass?: string;
};

type ToastService = {
  add: (message: ToastMessage) => void;
  remove?: (message: ToastMessage) => void;
  removeGroup?: (group: string) => void;
  removeAllGroups?: () => void;
};

function resolveToastService(): ToastService | null {
  const instance = getCurrentInstance();
  const fromInstance = instance?.appContext.config.globalProperties.$toast;
  const fromVueGlobal = window.$vue?.config?.globalProperties?.$toast;
  const candidate = fromInstance ?? fromVueGlobal;

  if (candidate && typeof candidate.add === "function") {
    return candidate as ToastService;
  }

  return null;
}

export function useToastService(): ToastService {
  return {
    add(message) {
      const toastService = resolveToastService();
      if (!toastService) {
        console.warn("PrimeVue ToastService is not ready yet");
        return;
      }

      toastService.add(message);
    },
    remove(message) {
      resolveToastService()?.remove?.(message);
    },
    removeGroup(group) {
      resolveToastService()?.removeGroup?.(group);
    },
    removeAllGroups() {
      resolveToastService()?.removeAllGroups?.();
    },
  };
}
